import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export const VideoSlider = ({ list, id, name }) => {
  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered custom-modal-size"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header bg-gray-700 p-4">
            <h5 className="modal-title text-white" id="domainlLabel">
              {name} Videos
            </h5>
            <button
              type="button"
              className="close opacity-100"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i aria-hidden="true" className="ki ki-close text-white"></i>
            </button>
          </div>
          <div className="modal-body p-3 custom-modal-size">
            <div className="verifi-slider review-slider">
              <Carousel showIndicators={false} showThumbs={false}>
                {list?.videoUrl?.map((videos, index) => {
                  return (
                    <div key={index.toString()}>
                      {videos && (
                        <iframe
                          id="video_modal"
                          src={videos}
                          type="video/mp4"
                          title="video"
                        ></iframe>
                      )}
                    </div>
                  );
                })}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
